/** A navigate offer or auto-executed data lookup, mirroring iOS `BotAction`. */
export interface BotAction {
  type: string;
  params?: Record<string, string>;
  label?: string;
  autoExecute: boolean;
}

export interface ChatMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  actions?: BotAction[];
  /** [RESULT: …] round-trips ride through history but are never rendered. */
  hidden?: boolean;
}

export type TurnEvent =
  | { kind: "text"; text: string }
  | { kind: "tool"; name: string; params: Record<string, string> }
  | { kind: "error"; message: string };

export interface FroshBotEngine {
  /** Whether tool markers round-trip ([RESULT:]) or resolve locally. */
  readonly live: boolean;
  readonly history: ChatMessage[];
  sendTurn(
    content: string,
    opts: { hidden?: boolean },
    onEvent: (event: TurnEvent) => void,
  ): Promise<void>;
}

export function makeMessage(partial: Omit<ChatMessage, "id">): ChatMessage {
  return { id: crypto.randomUUID(), ...partial };
}
